import {shopAxios} from "./axios";
import {CouponType, ResponseType, ShopTypes} from "../bll/types";


export const shopAPI = {
    async getShops() {
        return shopAxios.get<ShopTypes[]>('public/shops').then(r => r.data)
    },

    async getShopById(shopId: number) {
        return shopAxios.get<ShopTypes>(`public/shops/${shopId}`).then(r => r.data)
    },

    async getCouponsByShopId(shopId: number) {
        return shopAxios.get<CouponType[]>(`public/shops/${shopId}/coupons`).then(r => r.data)
    }
}